import type { Language } from '../../core/types/language';
import useCancelableQuery from '../../core/hooks/apollo/useCancelableQuery';
import { totalCountQuery } from './productListQuery';

const defaultCategoriesQueryResult = {
    products: {
        total: 0,
    },
};

const useProductListTotal = ({
    store,
    language,
    categoryId,
    preorderSeasonId,
    includePreorderSeasonId,
    includeExcludedCategories,
    skip,
}: {
    store: string;
    language: Language;
    categoryId?: string;
    preorderSeasonId?: number;
    skip?: boolean;
    includePreorderSeasonId?: number;
    includeExcludedCategories?: boolean;
}) => {
    const {
        data: { products: { total } } = defaultCategoriesQueryResult,
        loading: totalRequestLoading,
        error,
    } = useCancelableQuery<{
        products: {
            total: number;
        };
    }>(
        totalCountQuery,
        {
            variables: {
                store,
                language,
                categoryId,
                preorderSeasonId,
                includePreorderSeasonId,
                includeExcludedCategories,
                fetchPolicy: 'cache-first',
            },
            skip,
        },
        true
    );
    return { total, totalRequestLoading, error };
};

export default useProductListTotal;
